import { isDesktopHost } from '../../../../../../infrastructure/runtime';
import screenHeaderBackgroundDesktopImg from './screen_header_background.png';
import screenHeaderBackgroundMobileImg from './screen_header_background_mobile.png';

export function getScreenHeaderBackgroundUrl(
  desktop: boolean = isDesktopHost(),
): string {
  return desktop
    ? screenHeaderBackgroundDesktopImg
    : screenHeaderBackgroundMobileImg;
}
